import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import useJwt from '@/auth/jwt/useJwt';

export default {
  computed:{
    pickupFilter() {
      const location = [
        ...this.pickupFilterRegionID,
        ...this.deliveryFilterRegionID,
      ];

      return location;
    },
    deliveryFilter() {
      this.quotationInfo.delivery_location = "";
      const location = [
        ...this.pickupFilterRegionID,
        ...this.deliveryFilterRegionID,
      ];

      const regionID = location.find(
        (e) => e.id == this.quotationInfo.pickup_location
      );
      return regionID?.region_id
        ? location.filter((e) => e.region_id != regionID.region_id)
        : location;
    },

    // quotationInfo.pickup_location
    pickupFilterRegionID() {
      const result = this.useLocations.filter(
        (e) => e.region_id == this.request_quotation.pickup_region
      );

      return result.length ? result : this.useLocations;
    },
    deliveryFilterRegionID() {
      const result = this.useLocations.filter(
        (e) => e.region_id == this.request_quotation.delivery_region
      );

      return result.length ? result : this.useLocations;
    },
  },

  methods: {
    getLocation(){
      useJwt
      .get("getLocationsByUserId", { params: { page: 1, pageSize: 1000, userId: this.request_quotation.customer_id } })
      .then(
        (response) =>
          (this.useLocations = response.data.result.map((e) => {
            const result = {};

            result.text =
                e.abbreviations + " - " + e.detail_address || e.location;
              result.id = e.location_id;
              result.name = e.location;
              result.abbreviations = e.abbreviations;
              result.region_id = e.region_id;
              
              result.address = e.detail_address || e.location;
            return result;
          }))
      )
      .finally(() => {
        this.$loading.hide();
      });
    },
    async onSubmit() {
      var validate = await this.$refs.requestSubmit.validate().then(success => {
        return success;
      });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t('notifyFormError'),
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }
      this.$loading.show();

      useJwt
        .put('wr1?objectType=AcceptQuotation', {
          id: this.quotationInfo.id,
          quotationInfo: this.quotationInfo,
        })
        .then(response => {
          var vm = this;

          this.$swal({
            icon: 'success',
            title: 'Shipment has been created successfully',
            text: 'Click here to view booking details!',
          }).then(function () {
            vm.$router.push({ name: 'user-my-booking' });
          });
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Accept Quotation error!',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        })
        .finally(() => this.$loading.hide());
    },
  },
};
